import React, { createContext, useContext } from 'react';

interface PinnedEventsContextType {
  isPinned: (eventId: string) => boolean;
  togglePin: (eventId: string, activityType?: string) => void;
}

const PinnedEventsContext = createContext<PinnedEventsContextType | null>(null);

export const PinnedEventsProvider: React.FC<{
  value: PinnedEventsContextType;
  children: React.ReactNode;
}> = ({ value, children }) => {
  return (
    <PinnedEventsContext.Provider value={value}>
      {children}
    </PinnedEventsContext.Provider>
  );
};

export const usePinnedEventsContext = () => {
  const context = useContext(PinnedEventsContext);
  return context;
};
